<template>
  <div class="container container-table">
    <div class="row vertical-10p">
      <template v-for="alert in alerts">
        <b-alert :show="alert.dismiss" dismissible :variant="alert.type">
          <h4>
            <i v-if="alert.type == 'success'" class="icon fa fa-check"></i>
            <i class="icon fa fa-ban" v-else></i>
            {{'alert_' + alert.type | translate}}!</h4>
          <li v-for="e in alert.message">
            {{e}}
          </li>
        </b-alert>
      </template>
      <div class="container">
        <div class="login-box box">
          <div class="login-logo">
            <router-link to="/">
              <img class="img-responsive center-block" src="static/img/logo-lg.svg">
            </router-link>
          </div>
          <div class="login-box-body">
            <p class="login-box-msg">
              {{'sign_in_to_start_session' | translate}}
            </p>
            <form @submit.prevent="checkCreds">
              <div class="form-group has-feedback">
                <input id="username" type="text" class="form-control" placeholder="Username" v-model="username">
                <span class="fa fa-at form-control-feedback"></span>
              </div>
              <div class="form-group has-feedback">
                <input id="password" type="password" class="form-control" placeholder="Password" v-model="password">
                <span class="fa fa-lock form-control-feedback"></span>
              </div>
              <div class="row">
                <div class="col-sm-4 col-xs-12 pull-right">
                  <button id="sign-in" type="submit" class="btn btn-success btn-block">
                    <i class="fa fa-check-circle-o mr-5"></i> {{'sign_in' | translate}}
                  </button>
                </div>
              </div>
            </form>
          </div>
          <div class="overlay" v-show="loading">
            <img class="loading-gif" src="/static/img/blabla.svg"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data (router) {
    return {
      section: 'Login',
      loading: false,
      username: '',
      password: '',
      language: 'de',
      response: '',
      alerts: []
    }
  },
  methods: {
    checkCreds () {
      let store = this.$store
      this.loading = true
      this.resetResponse()
      window.localStorage.clear()
      API.post('login', { username: this.username, password: this.password})
        .then(response => {
          let data = response.data
          store.commit('updateUser', data)
          store.commit('updateRoles', data.roles)
          store.commit('updateToken', JSON.parse(JSON.stringify(data.token)))
          store.commit('updateLoggedInStatus', true)
          API.get('orders/orderFilters')
            .then(response => {
              store.commit('updateOrderStatusFilters', response.data.status)
              store.commit('updateOrderPaymentsFilters', response.data.payments)
              store.commit('updateOrderChannelsFilters', response.data.channels)
            })
          this.$router.push('/home')
          this.loading = false
        })
        .catch(error => {
          let message = []
          let data = error.response.data
          Object.keys(data).forEach(x => {
            message.push(typeof data[x] === 'string' ? data[x] : data[x][0])
          })
          let alert = {type: 'danger', dismiss: 4, message: message}
          this.alerts.push(alert)
          this.loading = false
        })
    },
    toggleLoading () {
      this.loading = (this.loading === 'true') ? 'false' : 'true'
    },
    resetResponse () {
      this.response = ''
    }
  }
}
</script>

<style>
  .companie-select
  {
    width:80%;
    float: right;
  }
</style>
<style scoped>
  .loading-gif {
    top: 43%;
    left: 39%;
    width: 23%;
    position: absolute;
  }
</style>




// WEBPACK FOOTER //
// src/components/views/Login.vue